var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReported = function SvgReported(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Reported",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-1265.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Questionaire",
    transform: "translate(1265.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,2 C20.5128358,2 20.9355072,2.38604019 20.9932723,2.88337887 L21,3 L21,21 C21,21.5128358 20.6139598,21.9355072 20.1166211,21.9932723 L20,22 L5,22 C4.48716416,22 4.06449284,21.6139598 4.00672773,21.1166211 L4,21 L4,3 C4,2.48716416 4.38604019,2.06449284 4.88337887,2.00672773 L5,2 L20,2 Z M19,4 L6,4 L6,20 L19,20 L19,4 Z M17,14 L17,16 L12,16 L12,14 L17,14 Z M10,14 L10,16 L8,16 L8,14 L10,14 Z M17,10 L17,12 L12,12 L12,10 L17,10 Z M10,10 L10,12 L8,12 L8,10 L10,10 Z M17,6 L17,8 L12,8 L12,6 L17,6 Z M10,6 L10,8 L8,8 L8,6 L10,6 Z",
    id: "Icons/24/Questionnaire"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReported);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "reported.4ec5e200fecb1de7dbff8c78f67b4b6e.svg";